import axios from 'axios';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';
import {
    showWarningModal,
    showErrorModal,
    showExpiredSessionModal,
} from '@/redux/slices/modalAlertSlice';
import { msalInstance } from './msal';

let apiController = new AbortController();
const apiNWL = axios.create({
    baseURL: import.meta.env.VITE_APP_BASE_NWL_URL,
});

let access_token = localStorage.getItem('accessToken');
if (access_token) {
    apiNWL.defaults.headers.common = {
        'Content-Encoding': 'gzip',
    };
}

apiNWL.interceptors.request.use((config) => {
    store.dispatch(setShowLoader(true));
    const account = msalInstance.getAllAccounts()[0];
    return msalInstance
        .acquireTokenSilent({
            scopes: [import.meta.env.VITE_AZUREAD_CLIENTID],
            account: account,
        })
        .then((response) => {
            const accessToken = response.accessToken;
            config.headers.Authorization = `Bearer ${accessToken}`;
            return config;
        })
        .catch((error) => {
            store.dispatch(showExpiredSessionModal(true));
            console.error('Error acquiring token:', error);
            return Promise.reject(error);
        });
});

apiNWL.interceptors.response.use(
    (response) => {
        if (response.status === 200 || response.status === 201) {
            if (response.data.success === 0) {
                store.dispatch(showWarningModal('', response.data.message));
            }
        }
        store.dispatch(setShowLoader(false));
        return response;
    },
    (error) => {
        store.dispatch(setShowLoader(false));
        console.error('error', error);
        if (error.code === 'ERR_NETWORK') {
            window.location.href = '/error';
        } else if (
            error.code === 'ECONNABORTED' &&
            error.message.includes('timeout')
        ) {
            window.location.href = '/error';
        } else if (error.response && error.response.status === 429) {
            store.dispatch(
                showErrorModal(
                    'You have reached the limit of requests to the server. Retry in a few minutes.',
                    error.response?.data?.error,
                ),
            );
        } else if (error.code === 'ERR_CANCELED') {
        } else if (error.response && error.response.status === 500) {
            store.dispatch(
                showErrorModal(error.message, error.response?.data?.error),
            );
        } else {
            store.dispatch(
                showWarningModal(
                    error.response?.data?.type || 'Warning',
                    error.response?.data?.message ||
                    error.response?.data?.body?.message ||
                    'An error occurred',
                ),
            );
        }

        return Promise.reject(error);
    },
);

const restartApiCotroller = () => {
    apiController = new AbortController();
};

export { apiNWL, apiController, restartApiCotroller };
